// Viewport-relative rect for the caret inside a <textarea>/<input>.
//
// Textareas expose no DOM node at the caret, so we mirror the field into a
// hidden div, drop a marker span at the caret index, and read the marker's
// position. Standard "textarea-caret-position" technique.

const MIRRORED_PROPERTIES = [
  "direction", "boxSizing",
  "width", "height",
  "overflowX", "overflowY",
  "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth",
  "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
  "fontStyle", "fontVariant", "fontWeight", "fontStretch", "fontSize",
  "fontSizeAdjust", "lineHeight", "fontFamily",
  "textAlign", "textTransform", "textIndent", "textDecoration",
  "letterSpacing", "wordSpacing", "tabSize", "MozTabSize"
]

export function caretRect(field, index = field.selectionStart) {
  const isInput = field.nodeName === "INPUT"
  const computed = getComputedStyle(field)

  const mirror = document.createElement("div")
  const style = mirror.style
  style.position = "absolute"
  style.visibility = "hidden"
  style.whiteSpace = "pre-wrap"
  if (!isInput) style.wordWrap = "break-word"
  MIRRORED_PROPERTIES.forEach((prop) => { style[prop] = computed[prop] })

  mirror.textContent = field.value.substring(0, index)
  if (isInput) mirror.textContent = mirror.textContent.replace(/\s/g, " ")

  const marker = document.createElement("span")
  // A non-empty marker guarantees a laid-out box to measure against.
  marker.textContent = field.value.substring(index) || "."
  mirror.appendChild(marker)

  document.body.appendChild(mirror)
  const markerTop = marker.offsetTop
  const markerLeft = marker.offsetLeft
  document.body.removeChild(mirror)

  const fieldRect = field.getBoundingClientRect()
  const lineHeight = parseInt(computed.lineHeight) || parseInt(computed.fontSize)
  const top = fieldRect.top + markerTop - field.scrollTop
  const left = fieldRect.left + markerLeft - field.scrollLeft

  return new DOMRect(left, top, 0, lineHeight)
}
